module.exports = __webpack_public_path__ + "img/album18_55.5137a809.jpg";